import { ProductTypeEnum, RoleTypesEnum } from '@app/@core/enums';

interface MenuRolesModel {
  ConfigParamter?: number[];
  LicenseCenter?: number[];
  Licenses?: number[];
  Settings?: number[];
  Developer?: number[];
  Users?: number[];
  UserAlarm?: { roles?: number[], licenceType?: number[]; };
  FacilityReport?: number[];
  EnergyComparison?: number[];
  Download?: { roles?: number[], licenceType?: number[] };
}

export const MenuRoles: MenuRolesModel = {
  ConfigParamter: [RoleTypesEnum.ENTES, RoleTypesEnum.SystemAdmin],
  LicenseCenter: [RoleTypesEnum.ENTES],
  Licenses: [RoleTypesEnum.OrganizationManager, RoleTypesEnum.SectionManager, RoleTypesEnum.FacilityManager],
  Settings: [RoleTypesEnum.OrganizationManager, RoleTypesEnum.SectionManager, RoleTypesEnum.FacilityManager],
  Developer: [RoleTypesEnum.OrganizationManager, RoleTypesEnum.SectionManager, RoleTypesEnum.FacilityManager, RoleTypesEnum.ENTES],
  Users: [RoleTypesEnum.ENTES, RoleTypesEnum.SystemAdmin],
  UserAlarm: {
    roles: [RoleTypesEnum.OrganizationManager, RoleTypesEnum.SystemAdmin],
    licenceType: [ProductTypeEnum.EnergyDoctor, ProductTypeEnum.EnergyDoctorFree, ProductTypeEnum.Sentinel]
  },
  FacilityReport: [RoleTypesEnum.OrganizationManager, RoleTypesEnum.SectionManager, RoleTypesEnum.FacilityManager, RoleTypesEnum.BusinessPartner, RoleTypesEnum.SystemAdmin],
  EnergyComparison: [RoleTypesEnum.OrganizationManager, RoleTypesEnum.SectionManager, RoleTypesEnum.FacilityManager, RoleTypesEnum.SystemAdmin],
  Download: { roles: [RoleTypesEnum.OrganizationManager, RoleTypesEnum.SectionManager, RoleTypesEnum.FacilityManager], licenceType: [ProductTypeEnum.EnergyDoctor, ProductTypeEnum.EnergyDoctorFree, ProductTypeEnum.Enermedic, ProductTypeEnum.PowerFactorDoctor, ProductTypeEnum.PowerFactorDoctorFree] }
};
